import { ThemeAssets } from 'chessboard/config/theme-assets';
import type { Board } from 'chessboard/model/board/types';

/**
 * validates boardOptions are for 2D assets and returns the options correctly typed
 */
export function validateBoardOptions2D(
  options: Board.Options,
): Board.Options<ThemeAssets.Assets2D> {
  // throws if invalid
  validateThemeAssets2D(options.themeAssets);
  return options as Board.Options<ThemeAssets.Assets2D>;
}

/**
 * validates boardOptions are for 3D assets and returns the options correctly typed
 */
export function validateBoardOptions3D(
  options: Board.Options,
): Board.Options<ThemeAssets.Assets3D> {
  // throws if invalid
  validateThemeAssets3D(options.themeAssets);
  return options as Board.Options<ThemeAssets.Assets3D>;
}

/**
 * validates themeAssets are for 2D assets and returns the assets correctly typed
 */
export function validateThemeAssets2D(
  assets?: ThemeAssets.Assets,
): ThemeAssets.Assets2D | undefined {
  if (!assets) {
    return assets;
  }

  if (assets.config.perspective !== ThemeAssets.Perspective.REAL_3D) {
    return assets as ThemeAssets.Assets2D;
  }

  throw new Error('ThemeAssets: Expected 2D assets, received 3D assets');
}

/**
 * validates themeAssets are for 3D assets and returns the assets correctly typed
 */
export function validateThemeAssets3D(
  assets?: ThemeAssets.Assets,
): ThemeAssets.Assets3D | undefined {
  if (!assets) {
    return assets;
  }

  if (assets.config.perspective === ThemeAssets.Perspective.REAL_3D) {
    return assets as ThemeAssets.Assets3D;
  }

  throw new Error('ThemeAssets: Expected 3D assets, received 2D assets');
}
